import { FC, useEffect, useMemo } from 'react';

import { useLazyQuery } from '@apollo/client';
import { Box } from '@mui/material';

import { showErrorToast } from 'src/components/Toasts/toast';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';
import { GET_PARTNER } from 'src/graphql/queries/partners.query';
import { GET_PARTNER_OF_PARTNER } from 'src/graphql/queries/subpartners.query';

import { TextDisplay } from '../TextDisplay';

const PrincipalInformation: FC = () => {
    const { merchantApplication } = useAddMerchantContext();

    const [getPartner, { data }] = useLazyQuery(GET_PARTNER, {
        onError: (err) => {
            return showErrorToast(err.message);
        },
    });

    const [getPartnerOfPartner, { data: partnerOfPartnerData }] =
        useLazyQuery(GET_PARTNER_OF_PARTNER);

    useEffect(() => {
        const partnerId = merchantApplication?.partnerId;
        const partnerOfPartnerId = merchantApplication?.partnerOfPartnerId;
        if (partnerId) {
            getPartner({ variables: { id: partnerId } });
        }
        if (partnerOfPartnerId) {
            getPartnerOfPartner({ variables: { id: partnerOfPartnerId } });
        }
    }, []);

    const name = useMemo(() => {
        const legalPartnerName = data?.partner?.business?.legalName;
        if (legalPartnerName) {
            return legalPartnerName;
        } else {
            return null;
        }
    }, [data]);

    const partnerOfPartnerName = useMemo(() => {
        const legalParnerOfPartnerName =
            partnerOfPartnerData?.partnerOfPartner?.business?.legalName;

        if (legalParnerOfPartnerName) {
            return legalParnerOfPartnerName;
        } else {
            return null;
        }
    }, [partnerOfPartnerData]);

    return (
        <Box display="flex" flexDirection="column" gap="24px">
            <Box width="100%" display="flex" justifyContent="space-between">
                <TextDisplay label="Partner Name" value={partnerOfPartnerName || name} />
            </Box>
        </Box>
    );
};

export default PrincipalInformation;
